import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import bin from "../assets/images/bin.png";
import { apiCall } from "../services/AxiosService";
import { API_URL } from "../services/APIRoute";
import { apiResponse } from "../services/APIResponse";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { DeleteMethod } from "../services/ReduxTookit/Slice/DeleteRedux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

function ConfirmationModel(props) {
    async function fnDelete() {
        await props.functionCall();
    }
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className={`${props.isContactDeleteModelClass
                ? "contact-add-or-remove-model delete-modal"
                : "delete-modal"
                } ${props.isdeleteWebhookmodelClass && "delete-webhookmodel"}`}
            backdrop="static"
        >
            {props?.Loader && <MainpageLoader />}
            <Modal.Body>
                <div className="text-center">
                    {/* <img src={bin} alt="bin" className="modal-delete-icon" /> */}
                    <svg xmlns="http://www.w3.org/2000/svg" className="modal-regenerate-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" /><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" /></svg>
                    <h4>{props?.headertext}</h4>
                    <p>
                        {props?.messagetext}
                    </p>
                    <div className="d-flex align-items-center gap-2">
                        <button className="grey-btn" onClick={props.onHide}>
                            No, Keep
                        </button>
                        <button
                            className="blue-btn"
                            onClick={(e) => {
                                fnDelete();
                            }}
                        >
                            {props?.Loader ? (
                                <SubmitLoading />
                            ) : (
                                props?.yesbuttontext ? props?.yesbuttontext : "Yes, Sure"
                            )}
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ConfirmationModel;
